module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1534-01731c355226bd62994e60643e4aede2.png";